import { connectorMetadataGuard, googleOneTapConfigGuard, } from '@logto/connector-kit';
import { z } from 'zod';
import { CustomProfileFields, SignInExperiences, } from '../db-entries/index.js';
import { CaptchaType } from '../foundations/jsonb-types/index.js';
import { ssoConnectorMetadataGuard } from './sso-connector.js';
export const fullSignInExperienceGuard = SignInExperiences.guard
    .omit({ forgotPasswordMethods: true })
    .extend({
    socialConnectors: connectorMetadataGuard
        .omit({
        description: true,
        configTemplate: true,
        formItems: true,
        readme: true,
        customData: true,
    })
        .extend({
        confirmationPrompt: z.string().optional(),
        confirmationPromptI18n: z
            .object({
            en: z.string().optional(),
            'zh-CN': z.string().optional(),
        })
            .optional(),
        confirmationConfirmText: z.string().optional(),
        confirmationConfirmTextI18n: z
            .object({
            en: z.string().optional(),
            'zh-CN': z.string().optional(),
        })
            .optional(),
        confirmationCancelText: z.string().optional(),
        confirmationCancelTextI18n: z
            .object({
            en: z.string().optional(),
            'zh-CN': z.string().optional(),
        })
            .optional(),
    })
        .array(),
    directSocialConnectors: connectorMetadataGuard
        .omit({
        description: true,
        configTemplate: true,
        formItems: true,
        readme: true,
        customData: true,
    })
        .extend({
        confirmationPrompt: z.string().optional(),
        confirmationPromptI18n: z
            .object({
            en: z.string().optional(),
            'zh-CN': z.string().optional(),
        })
            .optional(),
        confirmationConfirmText: z.string().optional(),
        confirmationConfirmTextI18n: z
            .object({
            en: z.string().optional(),
            'zh-CN': z.string().optional(),
        })
            .optional(),
        confirmationCancelText: z.string().optional(),
        confirmationCancelTextI18n: z
            .object({
            en: z.string().optional(),
            'zh-CN': z.string().optional(),
        })
            .optional(),
    })
        .array(),
    ssoConnectors: ssoConnectorMetadataGuard.array(),
    forgotPassword: z.object({ phone: z.boolean(), email: z.boolean() }),
    isDevelopmentTenant: z.boolean(),
    googleOneTap: googleOneTapConfigGuard
        .extend({ clientId: z.string(), connectorId: z.string() })
        .optional(),
    captchaConfig: z
        .discriminatedUnion('type', [
        z.object({
            type: z.literal(CaptchaType.Turnstile),
            siteKey: z.string(),
        }),
        z.object({
            type: z.literal(CaptchaType.RecaptchaEnterprise),
            siteKey: z.string(),
        }),
        z.object({
            type: z.literal(CaptchaType.AliyunCaptcha),
            sceneId: z.string(),
            prefix: z.string(),
        }),
    ])
        .optional(),
    customProfileFields: CustomProfileFields.guard.array(),
});
